module.exports = __webpack_public_path__ + "img/4.20455124.jpeg";